import { render, staticRenderFns } from "./TreeDiaryGift.vue?vue&type=template&id=1733821e&"
import script from "./TreeDiaryGift.vue?vue&type=script&lang=ts&"
export * from "./TreeDiaryGift.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports